import type { IndividuoArboreo } from "@/types/ui-models";

interface Props {
  individuos: IndividuoArboreo[];
  comVistoriaValidada: number | null;
}

/** Percentuais calculados do cadastro real.  Sem exemplares, nao ha percentual a mostrar. */
export default function TreeQualityPanel({ individuos, comVistoriaValidada }: Props) {
  const total = individuos.length;
  const pct = (n: number) => (total ? Math.round((n / total) * 100) : 0);
  const metricas = [
    { label: "Coordenada informada", pct: pct(individuos.filter((i) => i.coordenada).length), color: "bg-primary-500" },
    { label: "Espécie identificada", pct: pct(individuos.filter((i) => i.nomeCientifico || i.nomePopular).length), color: "bg-primary-500" },
    ...(comVistoriaValidada !== null
      ? [{ label: "Com vistoria validada", pct: pct(comVistoriaValidada), color: "bg-accent-500" }]
      : []),
  ];

  return (
    <div className="bg-white rounded-card border border-background-200 p-5">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
          <i className="ri-shield-check-line text-accent-600 text-sm"></i>
        </div>
        <h3 className="text-sm font-semibold text-foreground-900 font-heading">Qualidade do Cadastro</h3>
      </div>
      {total === 0 ? (
        <p className="text-xs text-foreground-500">Nenhum exemplar cadastrado ainda.</p>
      ) : (
        <div className="space-y-3">
          {metricas.map((m) => (
            <div key={m.label}>
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs text-foreground-600">{m.label}</span>
                <span className="text-xs font-semibold text-foreground-900 tabular-nums">{m.pct}%</span>
              </div>
              <div className="h-1.5 rounded-full bg-background-200 overflow-hidden">
                <div
                  className={`h-full rounded-full ${m.color} transition-all duration-300`}
                  style={{ width: `${m.pct}%` }}
                  role="progressbar"
                  aria-valuenow={m.pct}
                  aria-valuemin={0}
                  aria-valuemax={100}
                  aria-label={`${m.label}: ${m.pct}%`}
                ></div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
